import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import promiseMiddleware from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import rootReducer from './reducer';

const history = createBrowserHistory();

const w = window as any;
const devTools = w.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleware = applyMiddleware(
  routerMiddleware(history),
  thunk,
  promiseMiddleware
);

const getMiddleware = (env: string) => {
  if (env === 'production') {
    if (typeof w.__REACT_DEVTOOLS_GLOBAL_HOOK__ === 'object') {
      w.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = () => {};
    }
    return middleware;
  }
  return devTools(middleware);
};

const getStore = (env: any) => {
  return createStore(rootReducer, getMiddleware(env));
};

export { history, getStore };
